import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

import nexusAtsLogo from "@/assets/logos/nexus-ats-logo.png";
import talentoSelectivoLogo from "@/assets/logos/talento-selectivo-logo.png";
import nexusAssessmentLogo from "@/assets/logos/nexus-assessment-logo.png";
import talentConnectLogo from "@/assets/logos/talent-connect-logo.png";
import talentPayLogo from "@/assets/logos/talent-pay-logo.png";
import profileLabLogo from "@/assets/logos/profile-lab-logo.png";
import orienta360Logo from "@/assets/logos/orienta360-logo.png";
import elempleoLogo from "@/assets/logos/elempleo-logo.png";
import nexusLanguagesLogo from "@/assets/logos/nexus-languages-logo.png";
import peopleLabsLogo from "@/assets/logos/people-labs-logo.png";
import talentPayCalculadoraLogo from "@/assets/logos/talent-pay-calculadora-logo.png";
import agenteLogo from "@/assets/logos/employee-hub-logo.png";
import { cn } from "@/lib/utils";

const products: { label: string; to: string; logo: string }[] = [
  { label: "Nexus ATS", to: "/nexus-ats", logo: nexusAtsLogo },
  { label: "Employee Hub+", to: "/agente", logo: agenteLogo },
  { label: "Reclutamiento y Selección", to: "/reclutamiento-seleccion", logo: talentoSelectivoLogo },
  { label: "Pruebas Psicométricas", to: "/pruebas-psicometricas", logo: nexusAssessmentLogo },
  { label: "Talent Connect", to: "/talent-connect", logo: talentConnectLogo },
  { label: "Encuesta Salarial", to: "/encuesta-salarial", logo: talentPayLogo },
  { label: "Nexus Lab", to: "/nexus-lab", logo: profileLabLogo },
  { label: "Orienta360", to: "/orientacion-vocacional", logo: orienta360Logo },
  { label: "Elempleo", to: "/elempleo", logo: elempleoLogo },
  { label: "Nexus Languages", to: "/nexus-languages", logo: nexusLanguagesLogo },
  { label: "Encuesta Clima y Cultura", to: "/encuesta-clima-cultura", logo: peopleLabsLogo },
  { label: "Calculadora Salarial", to: "/calculadora-salarial", logo: talentPayCalculadoraLogo },
];

interface LeadThankYouCardProps {
  compact?: boolean;
  headingLevel?: "h1" | "h2";
  footer?: React.ReactNode;
}

const LeadThankYouCard: React.FC<LeadThankYouCardProps> = ({ compact = false, headingLevel = "h2", footer }) => {
  const Heading = headingLevel;

  return (
    <div className={cn("bg-white rounded-2xl p-6 md:p-10", !compact && "shadow-2xl")}>
      <div className="text-center mb-8">
        <div className="mx-auto mb-4 w-16 h-16 rounded-full bg-[#620AE2]/10 flex items-center justify-center">
          <CheckCircle2 className="w-9 h-9 text-[#620AE2]" />
        </div>
        <Heading className="font-exo font-bold mb-3" style={{ fontSize: "28px", color: "#1A1A2E" }}>
          ¡Gracias por su solicitud!
        </Heading>
        <p className="text-sm md:text-base text-muted-foreground max-w-xl mx-auto">
          Un especialista de Nexus HR le contactará a la brevedad. Mientras tanto, explore nuestros productos y descubra cómo podemos ayudarle.
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
        {products.map(({ label, to, logo }) => (
          <Link
            key={to}
            to={to}
            className="group flex flex-col items-center justify-center gap-2 p-4 rounded-xl border border-gray-200 hover:border-[#620AE2] hover:bg-[#620AE2]/5 transition-all duration-200 text-center"
          >
            <div className="w-12 h-12 rounded-lg bg-white group-hover:bg-[#620AE2]/10 flex items-center justify-center transition-colors p-1.5">
              <img
                src={logo}
                alt={label}
                className="h-full w-auto object-contain"
                loading="lazy"
                decoding="async"
              />
            </div>
            <span className="text-xs md:text-sm font-medium text-[#1A1A2E] leading-tight">
              {label}
            </span>
          </Link>
        ))}
      </div>

      {footer ? <div className="mt-8 text-center">{footer}</div> : null}
    </div>
  );
};

export default LeadThankYouCard;